'use strict';

const algolia = require('algoliasearch/lite');

class SearchClient {
  constructor(props) {
    const { config } = props;

    this.props = props;
    this.client = algolia(config.id, config.key).initIndex(config.index);
  }

  query(value) {
    const { client } = this;
    const { countryCode, domainId } = this.props;

    return client.search({
      query: value,
      facets: '*',
      hitsPerPage: 3,
      facetFilters: `excludedPlatforms:-7,status:1,countryCode:${countryCode},merchantDomains:${domainId}`,
    });
  }
}

module.exports = SearchClient;
